import { Map } from 'immutable';
import uuid from 'uuid';
import { whichSeason } from '../../lib/seasons';

export function makeHeaders(state, { data }) {
  const accessToken = state.getIn(['account', 'accessToken']);
  const deviceId = state.getIn(['device', 'deviceId']);

  const headers = new Headers();

  // Please do not send an authorization header unless
  // you have a token, as it will end in a space and
  // iOS 9.x will throw an error if a header starts
  // or ends in a space
  if (accessToken) {
    headers.append('Authorization', `bearer ${accessToken}`);
  }

  headers.append('Cache-Control', 'no-cache');
  headers.append('X-Tanda-Version', process.env.BUNDLE_VERSION);
  headers.append('X-Tanda-Device', deviceId || '');
  headers.append('Content-Type', 'application/json');

  if (data && data.time) {
    headers.append('X-Tanda-Season', whichSeason(new Date(data.time * 1000)));
  }

  return headers;
}

export function newRequest(request) {
  return new Map({ ...request, id: uuid() });
}

export function clearSystemMessages(dispatch, removeByType) {
  dispatch(removeByType('authError'));
  dispatch(removeByType('billingError'));
  dispatch(removeByType('deviceError'));
  dispatch(removeByType('noNetwork'));
  dispatch(removeByType('forbiddenError'));
}

let date = new Date();
date.setMinutes(0);
date.setSeconds(0);
date = date.getTime() / 1000;

const twohundy = body => ({ status: 200, body });

const responses = {
  clocked_in: twohundy([]),
  locations: twohundy([]),
  settings: twohundy({
    enable_availability: true,
    enable_employee_leave: true,
    leave_request_default_length: 7.6,
  }),
  shift_details: twohundy([{
    department_id: 1,
    id: 1,
    name: 'Waiter',
  }]),
  departments: twohundy([{
    colour: '#6be8ff',
    export_name: null,
    id: 1,
    location_id: 1,
    managers: [2],
    name: 'Front of House',
  }]),
  me: twohundy({
    active: true,
    date_of_birth: '1993-08-07',
    department_ids: [1],
    id: 2,
    managed_department_ids: [1],
    name: 'Anna Manager',
    passcode: '1111',
    user_levels: ['manager', 'employee'],
    utc_offset: 36000,
    organisations: [],
  }),
  users: twohundy([{
    active: true,
    date_of_birth: '1967-11-28',
    department_ids: [1],
    id: 1,
    managed_department_ids: [],
    name: 'John Smith',
    passcode: '1234',
    user_levels: ['employee'],
    utc_offset: 36000,
  }, {
    active: true,
    date_of_birth: '1993-08-07',
    department_ids: [1],
    id: 2,
    managed_department_ids: [1],
    name: 'Anna Manager',
    passcode: '1111',
    user_levels: ['manager', 'employee'],
    utc_offset: 36000,
  }]),
  schedules: twohundy([{
    department_id: 1,
    finish: date + (60 * 60 * 8), // 8 hours later
    id: 1,
    roster_id: 1,
    shift_detail_id: 1,
    start: date,
    user_id: 1,
  }, {
    department_id: 1,
    finish: date + (60 * 60 * 24), // 1 day later
    id: 2,
    shift_detail_id: null,
    start: date + (60 * 60 * 18), // 18 hours later
    user_id: 1,
  }]),
  types_for: twohundy([
    'Annual Leave',
    'Sick Leave',
  ]),
  leave_balances: twohundy([{
    leave_type: 'Annual Leave',
    hours: 17,
  }]),
  clockins: twohundy(),
  unavailability: {
    status: 201,
    body: {
      finish: 1474506000,
      id: 1,
      repeating: false,
      repeating_info: null,
      start: 1474416000,
      title: 'Demo Unavailability Request',
      updated_at: 1474330827,
      user_id: 1,
    },
  },
  leave: {
    status: 201,
    body: {
      finish: '2016-09-30',
      hours: 7.6,
      id: 498645,
      leave_type: 'Sick Leave',
      multitagging: false,
      reason: 'Demo Leave Request',
      start: '2016-09-28',
      status: 'pending',
      updated_at: 1474329832,
      user_id: 1,
    },
  },
};

export function handleDemoRequest({ endpoint }) {
  return new Promise((resolve, reject) => {
    const response = Object.entries(responses).find(([key]) => {
      const re = new RegExp(key);
      return re.test(endpoint);
    }); // return the value
    if (!response) {
      return reject(new Error(`Call to ${endpoint} failed!`));
    }
    const result = response[1];
    return resolve({
      headers: {
        get() { return 'application/json'; },
      },
      ok: true,
      status: result.status,
      json: () => result.body,
    });
  });
}



// WEBPACK FOOTER //
// ./src/store/requests/lib.js